<div class="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
  <div class="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-md">
    <h1 class="text-3xl font-extrabold text-gray-900 mb-6 text-center">Disclaimer</h1>

    <div class="space-y-6 text-gray-700 leading-relaxed">
      <p>
        <strong>Hector Investment L.L.C O.P.C</strong> is Registered with License No:CN-5228808 at Abu Dhabi, U.A.E.
      </p>
      <p>
        <strong>Hector Investment L.L.C O.P.C</strong> is acting as Investment Agent for Bodies, Organizations, and International Companies inside and outside of U.A.E.
      </p>
      <p>
        <strong>Hector Investment L.L.C O.P.C</strong> has A.I Digital Platform which bridges the Investors & Investees across the world by displaying their Portfolio's Data as an Investment Agent, but neither selling nor Promoting Securities.
      </p>
      <p>
        <strong>Hector Investment L.L.C O.P.C</strong> with registered L.E.I Number 98450085A1DBEC47E094 Participating in Global Regulated Financial Transactions.
      </p>

      <h2 class="text-xl font-bold text-gray-800 mt-8 mb-4">Not Investment Advice:</h2>
      <p>
        The content of this website is not intended to be and does not constitute investment advice. All investment decisions should be made based on your own due diligence and in consultation with an independent financial advisor.
      </p>

      <h2 class="text-xl font-bold text-gray-800 mt-8 mb-4">Risk of Loss:</h2>
      <p>
        Investing in financial markets, including real estate, clean energy, AI, and agriculture, involves a substantial risk of loss and is not suitable for every investor. The value of investments can go down as well as up, and you may not get back the full amount you invested.
      </p>

      <h2 class="text-xl font-bold text-gray-800 mt-8 mb-4">Projections and ROI Calculator:</h2>
      <p>
        Any projections, estimates, or return potentials (including those generated by the ROI Calculator) are based on current Market trends, and are not guarantees of future results would be the same.
      </p>

      <h2 class="text-xl font-bold text-gray-800 mt-8 mb-4">Limitation of Liability:</h2>
      <p>
        Under no circumstance shall Hector Investment LLC-OPC have any liability to you for any loss or damage of any kind incurred as a result of the use of the site or reliance on any information provided on the site. Your use of the site and your reliance on any information on the site is solely at your own risk.
      </p>
    </div>
  </div>
</div>